import React, { useState } from 'react'
import InsuranceDetail from './InsuranceDetail'

function fmt(n) {
  n = Math.round(n)
  if (n >= 10000000) return '₹' + (n / 10000000).toFixed(1) + ' Cr'
  if (n >= 100000) return '₹' + (n / 100000).toFixed(1) + ' L'
  if (n >= 1000) return '₹' + n.toLocaleString('en-IN')
  return '₹' + n
}

const TYPE_COLORS = {
  life: '#3d4a5c', health: '#4a6741', vehicle: '#b8441a', home: '#7a5d1e', other: '#8a8278'
}
const TYPE_LABELS = { life: 'Life', health: 'Health', vehicle: 'Vehicle', home: 'Home', other: 'Other' }
const FREQ_LABELS = { monthly: '/mo', quarterly: '/qtr', 'half-yearly': '/6mo', yearly: '/yr' }
const TYPE_FILTERS = [
  { id: 'all', label: 'All' },
  { id: 'life', label: 'Life' },
  { id: 'health', label: 'Health' },
  { id: 'vehicle', label: 'Vehicle' },
  { id: 'home', label: 'Home' },
  { id: 'other', label: 'Other' }
]

function daysUntilExpiry(expiry_date) {
  if (!expiry_date) return null
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const exp = new Date(expiry_date)
  exp.setHours(0, 0, 0, 0)
  return Math.round((exp - today) / (1000 * 60 * 60 * 24))
}

export default function InsuranceList({ policies, payments, claims, currentMonth, onAdd, onEdit, onDelete, onSetPayment, loading }) {
  const [search, setSearch] = useState('')
  const [typeFilter, setTypeFilter] = useState('all')
  const [detailPolicy, setDetailPolicy] = useState(null)

  const filtered = policies.filter(p => {
    const matchSearch = !search || p.name.toLowerCase().includes(search.toLowerCase())
    const matchType = typeFilter === 'all' || p.type === typeFilter
    return matchSearch && matchType
  })

  return (
    <div style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: '8px', overflow: 'hidden' }}>
      <div style={{ background: 'var(--surface-hdr)', borderBottom: '1px solid var(--border)', padding: '1rem 1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div>
          <span style={{ fontFamily: 'Georgia,serif', fontSize: '1.1rem', fontWeight: '700', color: 'var(--text)' }}>Insurance Policies</span>
          <span style={{ fontFamily: 'monospace', fontSize: '0.65rem', color: 'var(--text-muted)', marginLeft: '0.75rem' }}>
            {filtered.length !== policies.length
              ? `${filtered.length} of ${policies.length}`
              : `${policies.length}`} polic{policies.length !== 1 ? 'ies' : 'y'}
          </span>
        </div>
        <button
          onClick={onAdd}
          style={{ background: 'var(--btn-bg)', color: 'var(--btn-text)', border: 'none', padding: '0.45rem 0.9rem', borderRadius: '4px', fontFamily: 'monospace', fontSize: '0.72rem', fontWeight: '500', cursor: 'pointer', textTransform: 'uppercase', letterSpacing: '0.05em' }}
        >
          + Add Policy
        </button>
      </div>

      {policies.length > 0 && (
        <div style={{ padding: '0.85rem 1.5rem', borderBottom: '1px solid var(--border)', display: 'flex', flexDirection: 'column', gap: '0.6rem', background: 'var(--bg)' }}>
          <input
            value={search}
            onChange={e => setSearch(e.target.value)}
            placeholder="Search policies by name..."
            style={{ background: 'var(--input-bg)', border: '1px solid var(--border)', borderRadius: '4px', padding: '0.45rem 0.75rem', fontSize: '0.82rem', fontFamily: 'DM Sans, sans-serif', color: 'var(--text)', outline: 'none', width: '100%', boxSizing: 'border-box' }}
          />
          <div style={{ display: 'flex', gap: '0.4rem', flexWrap: 'wrap' }}>
            {TYPE_FILTERS.map(f => (
              <button
                key={f.id}
                onClick={() => setTypeFilter(f.id)}
                style={{ background: typeFilter === f.id ? 'var(--btn-bg)' : 'transparent', color: typeFilter === f.id ? 'var(--btn-text)' : 'var(--text-muted)', border: '1px solid var(--border)', borderRadius: '99px', padding: '0.22rem 0.7rem', fontFamily: 'monospace', fontSize: '0.62rem', cursor: 'pointer', textTransform: 'uppercase', letterSpacing: '0.05em', transition: 'all 0.15s' }}
              >
                {f.label}
              </button>
            ))}
          </div>
        </div>
      )}

      {loading && (
        <div style={{ padding: '3rem', textAlign: 'center', color: 'var(--text-muted)', fontFamily: 'monospace', fontSize: '0.8rem' }}>
          Loading policies...
        </div>
      )}

      {!loading && policies.length === 0 && (
        <div style={{ padding: '3.5rem 2rem', textAlign: 'center' }}>
          <div style={{ fontSize: '2.5rem', marginBottom: '0.75rem' }}>🛡️</div>
          <div style={{ fontFamily: 'Georgia,serif', fontSize: '1rem', fontWeight: '700', color: 'var(--text)', marginBottom: '0.3rem' }}>No insurance policies yet</div>
          <div style={{ fontFamily: 'monospace', fontSize: '0.72rem', color: 'var(--text-muted)', marginBottom: '1.2rem' }}>Add your policies to track premiums, renewals, and coverage</div>
          <button
            onClick={onAdd}
            style={{ background: 'var(--btn-bg)', color: 'var(--btn-text)', border: 'none', padding: '0.55rem 1.2rem', borderRadius: '4px', fontFamily: 'monospace', fontSize: '0.72rem', fontWeight: '500', cursor: 'pointer', textTransform: 'uppercase', letterSpacing: '0.05em' }}
          >
            + Add Policy
          </button>
        </div>
      )}

      {!loading && policies.length > 0 && filtered.length === 0 && (
        <div style={{ padding: '2rem', textAlign: 'center', color: 'var(--text-muted)', fontFamily: 'monospace', fontSize: '0.75rem' }}>
          No policies match your search or filter.
        </div>
      )}

      {!loading && filtered.map((policy, i) => {
        const typeColor = TYPE_COLORS[policy.type] || '#8a8278'
        const days = daysUntilExpiry(policy.expiry_date)
        const expColor = days === null ? 'var(--text-muted)' : days <= 0 ? '#b8441a' : days <= 30 ? '#b8441a' : days <= 90 ? '#c9a84c' : '#4a6741'
        const currentPay = payments.find(p => p.policy_id === policy.id && p.payment_month === currentMonth)
        const payStatus = currentPay?.status

        return (
          <div key={policy.id} style={{ borderBottom: i < filtered.length - 1 ? '1px solid var(--border)' : 'none', padding: '1.1rem 1.5rem' }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '1rem' }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.3rem', flexWrap: 'wrap' }}>
                  <span style={{ display: 'inline-block', background: typeColor, color: '#fff', padding: '0.12rem 0.4rem', borderRadius: '3px', fontFamily: 'monospace', fontSize: '0.58rem', textTransform: 'uppercase', letterSpacing: '0.06em', fontWeight: '700', flexShrink: 0 }}>
                    {TYPE_LABELS[policy.type] || policy.type}
                  </span>
                  <span style={{ fontFamily: 'Georgia,serif', fontSize: '0.98rem', fontWeight: '700', color: 'var(--text)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {policy.name}
                  </span>
                </div>
                {policy.provider && (
                  <div style={{ fontFamily: 'monospace', fontSize: '0.65rem', color: 'var(--text-muted)', marginBottom: '0.35rem' }}>{policy.provider}</div>
                )}
                <div style={{ display: 'flex', gap: '1.2rem', flexWrap: 'wrap' }}>
                  <div>
                    <span style={{ fontFamily: 'monospace', fontSize: '0.62rem', color: 'var(--text-muted)' }}>Premium </span>
                    <span style={{ fontFamily: 'monospace', fontSize: '0.75rem', fontWeight: '700', color: '#c9a84c' }}>{fmt(policy.premium_amount)}</span>
                    <span style={{ fontFamily: 'monospace', fontSize: '0.62rem', color: 'var(--text-muted)' }}>{FREQ_LABELS[policy.premium_frequency] || ''}</span>
                  </div>
                  {policy.sum_assured && (
                    <div>
                      <span style={{ fontFamily: 'monospace', fontSize: '0.62rem', color: 'var(--text-muted)' }}>Cover </span>
                      <span style={{ fontFamily: 'monospace', fontSize: '0.75rem', fontWeight: '700', color: 'var(--text)' }}>{fmt(policy.sum_assured)}</span>
                    </div>
                  )}
                  {days !== null && (
                    <div>
                      <span style={{ fontFamily: 'monospace', fontSize: '0.62rem', color: 'var(--text-muted)' }}>Expiry </span>
                      <span style={{ fontFamily: 'monospace', fontSize: '0.72rem', fontWeight: '700', color: expColor }}>
                        {days <= 0 ? 'Expired' : `${days}d`}
                      </span>
                    </div>
                  )}
                </div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '0.5rem', flexShrink: 0 }}>
                <div style={{ display: 'flex', gap: '0.25rem' }}>
                  {[
                    { s: 'paid', label: '✓ Paid', color: '#4a6741' },
                    { s: 'unpaid', label: '✗ Unpaid', color: '#b8441a' },
                    { s: 'na', label: 'N/A', color: 'var(--text-muted)' }
                  ].map(({ s, label, color }) => {
                    const active = payStatus === s
                    return (
                      <button
                        key={s}
                        onClick={() => onSetPayment(policy.id, s)}
                        style={{
                          background: active ? color : 'transparent',
                          color: active ? '#fff' : color,
                          border: `1px solid ${color}`,
                          borderRadius: '3px', padding: '0.2rem 0.45rem',
                          fontFamily: 'monospace', fontSize: '0.58rem',
                          cursor: 'pointer', fontWeight: active ? '700' : '400',
                          transition: 'all 0.15s', lineHeight: 1.2
                        }}
                      >
                        {label}
                      </button>
                    )
                  })}
                </div>

                <div style={{ display: 'flex', gap: '0.3rem' }}>
                  <button
                    onClick={() => setDetailPolicy(policy)}
                    style={{ background: 'transparent', border: '1px solid var(--border)', borderRadius: '3px', padding: '0.25rem 0.55rem', fontFamily: 'monospace', fontSize: '0.6rem', cursor: 'pointer', color: 'var(--text-muted)', transition: 'all 0.15s' }}
                    onMouseEnter={e => { e.target.style.borderColor = 'var(--text)'; e.target.style.color = 'var(--text)' }}
                    onMouseLeave={e => { e.target.style.borderColor = 'var(--border)'; e.target.style.color = 'var(--text-muted)' }}
                  >
                    Detail
                  </button>
                  <button
                    onClick={() => onEdit(policy)}
                    style={{ background: 'transparent', border: '1px solid var(--border)', borderRadius: '3px', padding: '0.25rem 0.55rem', fontFamily: 'monospace', fontSize: '0.6rem', cursor: 'pointer', color: 'var(--text-muted)', transition: 'all 0.15s' }}
                    onMouseEnter={e => { e.target.style.borderColor = 'var(--text)'; e.target.style.color = 'var(--text)' }}
                    onMouseLeave={e => { e.target.style.borderColor = 'var(--border)'; e.target.style.color = 'var(--text-muted)' }}
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => onDelete(policy.id)}
                    style={{ background: 'transparent', border: '1px solid rgba(184,68,26,0.3)', borderRadius: '3px', padding: '0.25rem 0.55rem', fontFamily: 'monospace', fontSize: '0.6rem', cursor: 'pointer', color: '#b8441a', transition: 'all 0.15s' }}
                    onMouseEnter={e => { e.target.style.borderColor = '#b8441a'; e.target.style.background = 'rgba(184,68,26,0.06)' }}
                    onMouseLeave={e => { e.target.style.borderColor = 'rgba(184,68,26,0.3)'; e.target.style.background = 'transparent' }}
                  >
                    Remove
                  </button>
                </div>
              </div>
            </div>
          </div>
        )
      })}

      {detailPolicy && (
        <InsuranceDetail
          policy={detailPolicy}
          payments={payments.filter(p => p.policy_id === detailPolicy.id)}
          claims={claims.filter(c => c.policy_id === detailPolicy.id)}
          onClose={() => setDetailPolicy(null)}
        />
      )}
    </div>
  )
}
